import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Ruler } from 'lucide-react';
import { COMPANY } from '../../config/company';

const ProjectMeasurementsCard = ({ language, lead, handleInputChange }) => {
  return (
    <Card>
      <CardHeader style={{ backgroundColor: COMPANY.primaryColor }} className="text-white rounded-t-lg">
        <CardTitle className="flex items-center">
          <Ruler className="mr-2 h-5 w-5" />
          {language === 'es' ? 'Medidas del Proyecto' : 'Project Measurements'}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-6 space-y-4">
        {/* ROOFING Measurements */}
        {(lead.project_category === 'roofing' || lead.project_category === 'tile_roof' || lead.project_category === 'shingle_roof' || lead.project_category === 'metal_roof' || lead.project_category === 'flat_roof' || lead.project_category === 'commercial_roofing') && (
          <>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <Label>{language === 'es' ? 'Área del Techo (sq ft)' : 'Roof Area (sq ft)'}</Label>
                <Input type="number" value={lead.roof_sqft || ''} onChange={(e) => handleInputChange('roof_sqft', e.target.value)} placeholder="e.g., 2500" data-testid="roof-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Número de Pisos' : 'Number of Stories'}</Label>
                <Select value={lead.stories || '1'} onValueChange={(value) => handleInputChange('stories', value)}>
                  <SelectTrigger data-testid="stories-select"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="1">{language === 'es' ? '1 Piso' : '1 Story'}</SelectItem>
                    <SelectItem value="2">{language === 'es' ? '2 Pisos' : '2 Stories'}</SelectItem>
                    <SelectItem value="3">{language === 'es' ? '3+ Pisos' : '3+ Stories'}</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>{language === 'es' ? 'Pendiente del Techo' : 'Roof Pitch'}</Label>
                <Select value={lead.roof_pitch || 'standard'} onValueChange={(value) => handleInputChange('roof_pitch', value)}>
                  <SelectTrigger data-testid="roof-pitch-select"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="low">{language === 'es' ? 'Baja (0-4:12)' : 'Low (0-4:12)'}</SelectItem>
                    <SelectItem value="standard">{language === 'es' ? 'Estándar (5-9:12)' : 'Standard (5-9:12)'}</SelectItem>
                    <SelectItem value="steep">{language === 'es' ? 'Pronunciada (10+:12)' : 'Steep (10+:12)'}</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className="grid grid-cols-4 gap-4">
              <div>
                <Label>{language === 'es' ? 'Aleros (pies lin.)' : 'Eaves (linear ft)'}</Label>
                <Input type="number" value={lead.roof_eaves || ''} onChange={(e) => handleInputChange('roof_eaves', e.target.value)} placeholder="e.g., 200" data-testid="roof-eaves" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Bordes (pies lin.)' : 'Rakes (linear ft)'}</Label>
                <Input type="number" value={lead.roof_rakes || ''} onChange={(e) => handleInputChange('roof_rakes', e.target.value)} placeholder="e.g., 150" data-testid="roof-rakes" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Cumbrera (pies lin.)' : 'Ridge (linear ft)'}</Label>
                <Input type="number" value={lead.roof_ridge || ''} onChange={(e) => handleInputChange('roof_ridge', e.target.value)} placeholder="e.g., 80" data-testid="roof-ridge" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Limahoyas (pies lin.)' : 'Valleys (linear ft)'}</Label>
                <Input type="number" value={lead.roof_valleys || ''} onChange={(e) => handleInputChange('roof_valleys', e.target.value)} placeholder="e.g., 60" data-testid="roof-valleys" />
              </div>
            </div>
          </>
        )}

        {/* KITCHEN Measurements */}
        {lead.project_category === 'kitchen' && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Espacio de Cocina (sq ft)' : 'Kitchen Space (sq ft)'}</Label>
                <Input type="number" value={lead.kitchen_sqft || ''} onChange={(e) => handleInputChange('kitchen_sqft', e.target.value)} placeholder="e.g., 150" data-testid="kitchen-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Gabinetes (pies lineales)' : 'Cabinets (linear ft)'}</Label>
                <Input type="number" value={lead.cabinet_lf || ''} onChange={(e) => handleInputChange('cabinet_lf', e.target.value)} placeholder="e.g., 25" data-testid="cabinet-lf" />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <Label>{language === 'es' ? 'Encimeras (sq ft)' : 'Countertops (sq ft)'}</Label>
                <Input type="number" value={lead.countertop_sqft || ''} onChange={(e) => handleInputChange('countertop_sqft', e.target.value)} placeholder="e.g., 40" data-testid="countertop-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Salpicadero (sq ft)' : 'Backsplash (sq ft)'}</Label>
                <Input type="number" value={lead.backsplash_sqft || ''} onChange={(e) => handleInputChange('backsplash_sqft', e.target.value)} placeholder="e.g., 30" data-testid="backsplash-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Número de Perillas' : 'Number of Knobs'}</Label>
                <Input type="number" value={lead.num_knobs || ''} onChange={(e) => handleInputChange('num_knobs', e.target.value)} placeholder="e.g., 20" data-testid="num-knobs" />
              </div>
            </div>
          </>
        )}

        {/* BATHROOM Measurements */}
        {lead.project_category === 'bathroom' && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Espacio de Baño (sq ft)' : 'Bathroom Space (sq ft)'}</Label>
                <Input type="number" value={lead.bathroom_sqft || ''} onChange={(e) => handleInputChange('bathroom_sqft', e.target.value)} placeholder="e.g., 60" data-testid="bathroom-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Número de Baños' : 'Number of Bathrooms'}</Label>
                <Select value={lead.num_bathrooms || '1'} onValueChange={(value) => handleInputChange('num_bathrooms', value)}>
                  <SelectTrigger data-testid="num-bathrooms-select"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="1">1</SelectItem>
                    <SelectItem value="2">2</SelectItem>
                    <SelectItem value="3">3+</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <Label>{language === 'es' ? 'Vanidad (pies lin.)' : 'Vanity (linear ft)'}</Label>
                <Input type="number" value={lead.vanity_lf || ''} onChange={(e) => handleInputChange('vanity_lf', e.target.value)} placeholder="e.g., 5" data-testid="vanity-lf" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Azulejo Piso (sq ft)' : 'Floor Tile (sq ft)'}</Label>
                <Input type="number" value={lead.floor_tile_sqft || ''} onChange={(e) => handleInputChange('floor_tile_sqft', e.target.value)} placeholder="e.g., 50" data-testid="floor-tile-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Azulejo Pared (sq ft)' : 'Wall Tile (sq ft)'}</Label>
                <Input type="number" value={lead.wall_tile_sqft || ''} onChange={(e) => handleInputChange('wall_tile_sqft', e.target.value)} placeholder="e.g., 80" data-testid="wall-tile-sqft" />
              </div>
            </div>
          </>
        )}

        {/* FLOORING Measurements */}
        {lead.project_category === 'flooring' && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Área de Piso (sq ft)' : 'Floor Area (sq ft)'}</Label>
                <Input type="number" value={lead.flooring_sqft || ''} onChange={(e) => handleInputChange('flooring_sqft', e.target.value)} placeholder="e.g., 1200" data-testid="flooring-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Rodapié (pies lin.)' : 'Baseboard (linear ft)'}</Label>
                <Input type="number" value={lead.baseboard_lf || ''} onChange={(e) => handleInputChange('baseboard_lf', e.target.value)} placeholder="e.g., 200" data-testid="baseboard-lf" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Tipo de Piso' : 'Flooring Type'}</Label>
                <Select value={lead.flooring_type || 'lvp'} onValueChange={(value) => handleInputChange('flooring_type', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="lvp">LVP</SelectItem>
                    <SelectItem value="hardwood">{language === 'es' ? 'Madera Dura' : 'Hardwood'}</SelectItem>
                    <SelectItem value="tile">{language === 'es' ? 'Azulejo' : 'Tile'}</SelectItem>
                    <SelectItem value="laminate">{language === 'es' ? 'Laminado' : 'Laminate'}</SelectItem>
                    <SelectItem value="carpet">{language === 'es' ? 'Alfombra' : 'Carpet'}</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>{language === 'es' ? 'Condición del Subpiso' : 'Subfloor Condition'}</Label>
                <Select value={lead.subfloor_condition || 'good'} onValueChange={(value) => handleInputChange('subfloor_condition', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="good">{language === 'es' ? 'Buena' : 'Good'}</SelectItem>
                    <SelectItem value="fair">{language === 'es' ? 'Regular' : 'Fair'}</SelectItem>
                    <SelectItem value="poor">{language === 'es' ? 'Mala' : 'Poor'}</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </>
        )}

        {/* PAINTING Measurements */}
        {(lead.project_category === 'room_painting' || lead.project_category === 'interior_painting') && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Área de Pintura (sq ft)' : 'Paint Area (sq ft)'}</Label>
                <Input type="number" value={lead.paint_sqft || ''} onChange={(e) => handleInputChange('paint_sqft', e.target.value)} placeholder="e.g., 2000" data-testid="paint-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Molduras (pies lin.)' : 'Trim (linear ft)'}</Label>
                <Input type="number" value={lead.trim_lf || ''} onChange={(e) => handleInputChange('trim_lf', e.target.value)} placeholder="e.g., 300" data-testid="trim-lf" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Número de Capas' : 'Number of Coats'}</Label>
                <Select value={lead.paint_coats || '2'} onValueChange={(value) => handleInputChange('paint_coats', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="1">1</SelectItem>
                    <SelectItem value="2">2</SelectItem>
                    <SelectItem value="3">3</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>{language === 'es' ? 'Altura de Pared' : 'Wall Height'}</Label>
                <Select value={lead.wall_height || 'standard'} onValueChange={(value) => handleInputChange('wall_height', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="standard">{language === 'es' ? 'Estándar (8-9 ft)' : 'Standard (8-9 ft)'}</SelectItem>
                    <SelectItem value="tall">{language === 'es' ? 'Alto (10-12 ft)' : 'Tall (10-12 ft)'}</SelectItem>
                    <SelectItem value="vaulted">{language === 'es' ? 'Abovedado (12+ ft)' : 'Vaulted (12+ ft)'}</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </>
        )}

        {/* POOL CONSTRUCTION Measurements */}
        {lead.project_category === 'pool_construction' && (
          <>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <Label>{language === 'es' ? 'Largo (ft)' : 'Length (ft)'}</Label>
                <Input type="number" value={lead.pool_length || ''} onChange={(e) => handleInputChange('pool_length', e.target.value)} placeholder="e.g., 30" data-testid="pool-length" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Ancho (ft)' : 'Width (ft)'}</Label>
                <Input type="number" value={lead.pool_width || ''} onChange={(e) => handleInputChange('pool_width', e.target.value)} placeholder="e.g., 15" data-testid="pool-width" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Profundidad (ft)' : 'Depth (ft)'}</Label>
                <Input type="number" value={lead.pool_depth || ''} onChange={(e) => handleInputChange('pool_depth', e.target.value)} placeholder="e.g., 6" data-testid="pool-depth" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Área de Deck (sq ft)' : 'Deck Area (sq ft)'}</Label>
                <Input type="number" value={lead.deck_sqft || ''} onChange={(e) => handleInputChange('deck_sqft', e.target.value)} placeholder="e.g., 500" data-testid="deck-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Tipo de Piscina' : 'Pool Type'}</Label>
                <Select value={lead.pool_type || 'gunite'} onValueChange={(value) => handleInputChange('pool_type', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="gunite">Gunite</SelectItem>
                    <SelectItem value="fiberglass">{language === 'es' ? 'Fibra de Vidrio' : 'Fiberglass'}</SelectItem>
                    <SelectItem value="vinyl">{language === 'es' ? 'Vinilo' : 'Vinyl'}</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </>
        )}

        {/* FENCE Measurements */}
        {lead.project_category === 'fence_installation' && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Largo de Cerca (pies lin.)' : 'Fence Length (linear ft)'}</Label>
                <Input type="number" value={lead.fence_lf || ''} onChange={(e) => handleInputChange('fence_lf', e.target.value)} placeholder="e.g., 150" data-testid="fence-lf" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Número de Puertas' : 'Number of Gates'}</Label>
                <Input type="number" value={lead.fence_gates || ''} onChange={(e) => handleInputChange('fence_gates', e.target.value)} placeholder="e.g., 2" data-testid="fence-gates" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Altura de Cerca (ft)' : 'Fence Height (ft)'}</Label>
                <Select value={lead.fence_height || '6'} onValueChange={(value) => handleInputChange('fence_height', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="4">4 ft</SelectItem>
                    <SelectItem value="6">6 ft</SelectItem>
                    <SelectItem value="8">8 ft</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>{language === 'es' ? 'Material de Cerca' : 'Fence Material'}</Label>
                <Select value={lead.fence_material || 'wood'} onValueChange={(value) => handleInputChange('fence_material', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="wood">{language === 'es' ? 'Madera' : 'Wood'}</SelectItem>
                    <SelectItem value="vinyl">{language === 'es' ? 'Vinilo' : 'Vinyl'}</SelectItem>
                    <SelectItem value="chain_link">{language === 'es' ? 'Malla Ciclónica' : 'Chain Link'}</SelectItem>
                    <SelectItem value="aluminum">{language === 'es' ? 'Aluminio' : 'Aluminum'}</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </>
        )}

        {/* CONCRETE Measurements */}
        {lead.project_category === 'concrete_work' && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Área de Concreto (sq ft)' : 'Concrete Area (sq ft)'}</Label>
                <Input type="number" value={lead.concrete_sqft || ''} onChange={(e) => handleInputChange('concrete_sqft', e.target.value)} placeholder="e.g., 400" data-testid="concrete-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Espesor (pulgadas)' : 'Thickness (inches)'}</Label>
                <Select value={lead.concrete_thickness || '4'} onValueChange={(value) => handleInputChange('concrete_thickness', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="4">4"</SelectItem>
                    <SelectItem value="6">6"</SelectItem>
                    <SelectItem value="8">8"</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </>
        )}

        {/* HVAC Measurements */}
        {(lead.project_category === 'hvac_replacement' || lead.project_category === 'hvac') && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Tonelaje' : 'Tonnage'}</Label>
                <Select value={lead.hvac_tonnage || '3'} onValueChange={(value) => handleInputChange('hvac_tonnage', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="1.5">1.5 Ton</SelectItem>
                    <SelectItem value="2">2 Ton</SelectItem>
                    <SelectItem value="2.5">2.5 Ton</SelectItem>
                    <SelectItem value="3">3 Ton</SelectItem>
                    <SelectItem value="3.5">3.5 Ton</SelectItem>
                    <SelectItem value="4">4 Ton</SelectItem>
                    <SelectItem value="5">5 Ton</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>{language === 'es' ? 'Unidades Interiores' : 'Indoor Units'}</Label>
                <Input type="number" value={lead.indoor_units || '1'} onChange={(e) => handleInputChange('indoor_units', e.target.value)} placeholder="e.g., 1" data-testid="indoor-units" />
              </div>
            </div>
          </>
        )}

        {/* WINDOW Measurements */}
        {lead.project_category === 'window_replacement' && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Número de Ventanas' : 'Number of Windows'}</Label>
                <Input type="number" value={lead.num_windows || ''} onChange={(e) => handleInputChange('num_windows', e.target.value)} placeholder="e.g., 10" data-testid="num-windows" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Tamaño Promedio (sq ft)' : 'Average Size (sq ft)'}</Label>
                <Input type="number" value={lead.window_avg_sqft || ''} onChange={(e) => handleInputChange('window_avg_sqft', e.target.value)} placeholder="e.g., 12" data-testid="window-avg-sqft" />
              </div>
            </div>
          </>
        )}

        {/* DRYWALL Measurements */}
        {lead.project_category === 'drywall_repair' && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Área de Drywall (sq ft)' : 'Drywall Area (sq ft)'}</Label>
                <Input type="number" value={lead.drywall_sqft || ''} onChange={(e) => handleInputChange('drywall_sqft', e.target.value)} placeholder="e.g., 200" data-testid="drywall-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Nivel de Acabado' : 'Finish Level'}</Label>
                <Select value={lead.finish_level_drywall || '4'} onValueChange={(value) => handleInputChange('finish_level_drywall', value)}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="3">{language === 'es' ? 'Nivel 3 (Textura)' : 'Level 3 (Texture)'}</SelectItem>
                    <SelectItem value="4">{language === 'es' ? 'Nivel 4 (Pintura Plana)' : 'Level 4 (Flat Paint)'}</SelectItem>
                    <SelectItem value="5">{language === 'es' ? 'Nivel 5 (Premium)' : 'Level 5 (Premium)'}</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </>
        )}

        {/* GENERAL/OTHER Categories - Show basic sq ft input */}
        {(lead.project_category === 'general' || lead.project_category === 'home_renovation' || lead.project_category === 'home_addition' || lead.project_category === 'new_construction' || lead.project_category === 'water_mitigation' || lead.project_category === 'mold_remediation' || lead.project_category === 'electrical' || lead.project_category === 'electrical_panel_upgrade' || lead.project_category === 'stucco_repair' || lead.project_category === 'soffit_fascia' || lead.project_category === 'gutter_installation' || lead.project_category === 'tile_installation' || lead.project_category === 'pressure_washing' || lead.project_category === 'popcorn_ceiling_removal' || lead.project_category === 'drain_line_replacement' || lead.project_category === 'water_heater_replacement' || !lead.project_category) && (
          <>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>{language === 'es' ? 'Área Total (sq ft)' : 'Total Area (sq ft)'}</Label>
                <Input type="number" value={lead.total_sqft || ''} onChange={(e) => handleInputChange('total_sqft', e.target.value)} placeholder="e.g., 500" data-testid="total-sqft" />
              </div>
              <div>
                <Label>{language === 'es' ? 'Número de Habitaciones' : 'Number of Rooms'}</Label>
                <Input type="number" value={lead.num_rooms || ''} onChange={(e) => handleInputChange('num_rooms', e.target.value)} placeholder="e.g., 3" data-testid="num-rooms" />
              </div>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default ProjectMeasurementsCard;
